import React from 'react';
import './AdultsAndJourney.css';

const AdultsAndJourney = () => {
  return (
    <div
      className="journey-parallax-wrapper"
      style={{
        '--bg-parallax': `url('${process.env.PUBLIC_URL}/assets/images/Hero-4.jpg')`
      }}
    >
      {/* SECTION 1: Online Quran Classes For Adults In The USA */}
      <section className="journey-parallax-section adult-classes" id="adult-classes">
        <div className="journey-parallax-section__container adult-classes__grid">
          {/* Left Column: Image */}
          <div className="adult-classes__image-container">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/Alquran-2.jpg`}
              alt="Adult learning Quran on laptop with headphones"
              className="adult-classes__img"
            />
          </div>

          {/* Right Column: Copy */}
          <div className="adult-classes__info">
            <h2 className="adult-classes__title">
              It's Never Too Late to Start Learning the Quran | Learn Quran Online for Kids and Adults!
            </h2>

            <p className="adult-classes__desc">
              A lot of adult Muslims grew up without proper Quranic education. Others learned as kids and lost fluency somewhere along the way. Some reverted to Islam later in life and are starting from nothing. So no matter where you're starting from, our online Quran classes for adults are built to meet you there, without judgment and without a pace that ignores the fact that you also have a job, a family, and a limited number of free evenings. We schedule your classes according to your availability and peace of mind so that you can learn Quran easily.
            </p>

            <p className="adult-classes__desc">
              Our tutors work with adults regularly, and they know the difference between teaching a kid and teaching someone busy, self-conscious about starting late, or simply out of practice. Whether your goal is finishing the Quran, memorizing it, understanding what you're reciting, or just reading it correctly with proper Tajweed, we have a tutor and a course for that.
            </p>

            <a href="/free-trial/" className="adult-classes__cta-btn">
              <span>Get Free Trial For Classes</span>
              <svg className="adult-classes__cta-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* SECTION 2: A Decade Of Quranic Education */}
      <section className="journey-parallax-section timeline-journey" id="timeline-journey">
        <div className="journey-parallax-section__container">
          <div className="timeline-journey__badge">Our Journey</div>

          <h2 className="timeline-journey__title">
            A Decade Of Quranic Education - How We Started
          </h2>

          <p className="timeline-journey__subtitle">
            From a small online classroom in 2013 to over 5,000 students across the USA, UK, and Canada. Here's how we grew.
          </p>

          <div className="timeline-journey__steps-container">
            {/* 2013 */}
            <div className="timeline-journey__step">
              <div className="timeline-journey__icon-wrapper">
                <svg className="timeline-journey__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                </svg>
              </div>
              <h3 className="timeline-journey__step-year">2013 — Founded</h3>
              <p className="timeline-journey__step-desc">
                Al Quran Lesson began with three certified tutors and one goal: to make real Quranic education accessible from home.
              </p>
            </div>

            {/* 2017 */}
            <div className="timeline-journey__step">
              <div className="timeline-journey__icon-wrapper">
                <svg className="timeline-journey__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                </svg>
              </div>
              <h3 className="timeline-journey__step-year">2017 — Expanded to the USA, UK, and CA</h3>
              <p className="timeline-journey__step-desc">
                We crossed our first major milestone, teaching families across the USA, UK, and CA with a growing team of 20+ tutors.
              </p>
            </div>

            {/* 2021 */}
            <div className="timeline-journey__step">
              <div className="timeline-journey__icon-wrapper">
                <svg className="timeline-journey__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
              </div>
              <h3 className="timeline-journey__step-year">2021 — 3,000+ students</h3>
              <p className="timeline-journey__step-desc">
                We expanded into <a style={{ textDecoration: "none", color: "#006100", fontWeight: "bold" }} href="/online-quran-classes-canada/">Canada</a> and introduced dedicated Hifz and <a style={{ textDecoration: "none", color: "#006100", fontWeight: "bold" }} href="/online-tajweed-classes-tajweed-course/">Tajweed programs</a> for more advanced students.
              </p>
            </div>

            {/* 2024 */}
            <div className="timeline-journey__step">
              <div className="timeline-journey__icon-wrapper">
                <svg className="timeline-journey__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17 10.43V2H7v8.43c-1.2.75-2 2.07-2 3.57 0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4 0-1.5-.8-2.82-2-3.57zM12 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
                </svg>
              </div>
              <h3 className="timeline-journey__step-year">2026 — 5,000+ students</h3>
              <p className="timeline-journey__step-desc">
                Today we teach 5,000+ students with 150+ certified male and female tutors, and hold an excellent rating of 4.6 stars.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdultsAndJourney;

